import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { EntityNotificationGroup } from './models/entity-notification-group.model';

export interface NotificationManagementState extends EntityState<EntityNotificationGroup> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'notification-management', idKey: 'NotificationGroupId' })
export class NotificationManagementStore extends EntityStore<NotificationManagementState> {
  constructor() {
    super();
  }
}
